module.exports = __webpack_public_path__ + "static/map-a0ffc61b30440b6f08d0f52b5509cbc6.png";